module.exports = __webpack_public_path__ + "static/game2-fbfff90017285b6e3322df529faebfe0.gif";